import { type PaymentTransactionId } from '@hooks-api/types/dataModel/eCommercePayments'
import { type PaymentMethod, PaymentMethodType } from '@hooks-api/types/dataModel/payment'

// Alipay HK / WeChat 不在此 —— 改在彈窗內 mount（見 getCkoAlipayDialogMountId / getCkoWeChatDialogMountId）。
const CKO_MOUNT_PREFIX_BY_TYPE: Partial<Record<PaymentMethodType, string>> = {
  [PaymentMethodType.CREDIT_CARD_ONCE]: 'cko-card-mount',
  [PaymentMethodType.CREDIT_CARD_INSTALLMENT]: 'cko-card-mount',
}

const CKO_CREDIT_CARD_METHOD_TYPES: PaymentMethodType[] = [
  PaymentMethodType.CREDIT_CARD_ONCE,
  PaymentMethodType.CREDIT_CARD_INSTALLMENT,
]

export const getCkoMountContainerId = (method: Pick<PaymentMethod, 'id' | 'type'> | undefined): string | null => {
  if (!method?.type) return null
  const prefix = CKO_MOUNT_PREFIX_BY_TYPE[method.type]
  if (!prefix) return null
  return `${prefix}-${method.id ?? 'wp'}`
}

/**
 * DOM id for the CKO `stored_card` SDK component. Only valid for credit-card
 * payment methods; returns `null` for everything else so the caller skips wiring.
 */
export const getCkoStoredCardMountContainerId = (method: Pick<PaymentMethod, 'id' | 'type'> | undefined): string | null => {
  if (!method?.type) return null
  if (!CKO_CREDIT_CARD_METHOD_TYPES.includes(method.type)) return null
  return `cko-storedcard-mount-${method.id ?? 'wp'}`
}

/** dialog 一律在建單後才開啟，transaction id 必定存在，故此處收緊為必填。 */
export type DialogPaymentTransactionId = NonNullable<PaymentTransactionId>

export const getCkoCreditCardDialogMountId = (paymentTransactionId: DialogPaymentTransactionId): string =>
  `cko-creditcard-dialog-mount-${paymentTransactionId}`

/** 刻意與 `getCkoStoredCardMountContainerId` 使用不同 id，避免與仍渲染 inline 容器的頁面共用 id 時 `querySelector` 解析到錯的節點。 */
export const getCkoStoredCardDialogMountId = (paymentTransactionId: DialogPaymentTransactionId): string =>
  `cko-storedcard-dialog-mount-${paymentTransactionId}`

export const getCkoApplePayDialogMountId = (paymentTransactionId: DialogPaymentTransactionId): string =>
  `cko-applepay-dialog-mount-${paymentTransactionId}`

export const getCkoAlipayDialogMountId = (paymentTransactionId: DialogPaymentTransactionId): string =>
  `cko-alipay-dialog-mount-${paymentTransactionId}`

export const getCkoWeChatDialogMountId = (paymentTransactionId: DialogPaymentTransactionId): string =>
  `cko-wechatpay-dialog-mount-${paymentTransactionId}`
